import React from 'react';
import { FaUsers, FaUser, FaPlus, FaCog, FaBellSlash } from 'react-icons/fa';

export function ConversationList({ conversations, selectedId, onSelect, onNewDM, onOpenSettings }) {
  return (
    <div className="h-full flex flex-col">
      <div className="p-4 border-b border-gray-200 flex justify-between items-center">
        <h2 className="text-lg font-bold text-gray-800">Messages</h2>
        <div className="flex items-center space-x-2">
          <button
            onClick={onOpenSettings}
            className="flex items-center gap-1 px-2 py-1.5 sm:p-2 text-gray-500 hover:bg-gray-100 rounded-full text-xs sm:text-sm"
            title="Settings"
            data-testid="settings-btn"
          >
            <FaCog />
            <span className="sm:hidden">Settings</span>
          </button>
          <button
            onClick={onNewDM}
            className="flex items-center gap-1 px-2 py-1.5 sm:p-2 text-blue-600 hover:bg-blue-50 rounded-full text-xs sm:text-sm"
            title="New message"
            data-testid="new-dm-btn"
          >
            <FaPlus />
            <span className="sm:hidden">New</span>
          </button>
        </div>
      </div>
      
      <div className="flex-1 overflow-y-auto">
        {conversations.length === 0 ? (
          <div className="p-4 text-center text-gray-500">
            <FaUsers className="text-4xl mx-auto mb-2 text-gray-300" />
            <p>No conversations yet</p>
            <p className="text-sm mt-1">Start a conversation with a family member</p>
          </div>
        ) : (
          conversations.map((conv) => (
            <button
              key={conv.conversation_id}
              onClick={() => onSelect(conv)}
              className={`w-full p-4 text-left border-b border-gray-100 hover:bg-gray-50 transition ${
                selectedId === conv.conversation_id ? 'bg-blue-50 border-l-4 border-l-blue-600' : ''
              }`}
              data-testid={`conversation-${conv.conversation_id}`}
            >
              <div className="flex items-center space-x-3">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center ${
                  conv.type === 'family' ? 'bg-blue-100 text-blue-600' : 'bg-purple-100 text-purple-600'
                }`}>
                  {conv.type === 'family' ? <FaUsers /> : <FaUser />}
                </div>
                
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between">
                    <span className="font-medium text-gray-800 truncate">
                      {conv.display_name}
                    </span>
                    {conv.is_muted && (
                      <FaBellSlash className="text-gray-400 text-sm ml-2" />
                    )}
                  </div>
                  
                  {conv.last_message && (
                    <p className="text-sm text-gray-500 truncate">
                      {conv.last_message.sender_name}: {conv.last_message.content}
                    </p>
                  )}
                </div>
                
                {conv.unread_count > 0 && (
                  <span className="bg-blue-600 text-white text-xs rounded-full px-2 py-1">
                    {conv.unread_count}
                  </span>
                )}
              </div>
            </button>
          ))
        )}
      </div>
    </div>
  );
}
